import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/category/product/CategorySidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/category/product/FAQAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/category/product/ProductInfinite.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
